import React, { useState, useEffect} from 'react';
import axios from 'axios';


    const VenueCategories = ({cityName, CityUniqueLink, BASE_URL, INVITES_API}) => {

        const [categories, setCategories] = useState([]);
        const [isLoading, setIsLoading] = useState(true);
        const BASEURL = `${BASE_URL}banquets`;
        const APIURL = `${INVITES_API}api`

        const categoriesImages= [
            {
                title: "Birthday Party",
                image: "../../media/occasion_birthday.png"
            },
            {
                title: "Wedding",
                image: "../../media/occasion_wedding.png"
            },
            {
                title: "Conference",
                image: "../../media/occasion_conference.png"
            },
            {
                title: "Cocktail Party",
                image: "../../media/occasion_cocktail_party.png"
            },
            {
                title: "Engagement",
                image: "../../media/occasion_engagement.png"
            },
            {
                title: "Social Gathering",
                image: "../../media/occasion_get_together.png"
            }
            ];

    useEffect(() => {
        const controller = new AbortController(); // Create an abort controller

        const fetchCategories = async () => {
        try {
            const response = await axios.get(
            `${APIURL}/city-page/occasions`,
            { signal: controller.signal }
            );

                const categoryData = response.data.map((category) => {
                    const matchedImage = categoriesImages.find(
                    (image) => image.title === category.occasionName
                    );
                
                    return {
                    ...category,
                    image: matchedImage ? matchedImage.image : null, // fallback to null if no match
                    };
                });
            
            setCategories(categoryData);
        } catch (error) {
            if (error.name !== "AbortError") {
            console.error("Error fetching categories:", error);
            }
        } finally {
            setIsLoading(false);
        }
        };

        fetchCategories();

        return () => controller.abort(); // Cleanup: cancel the request if the component unmounts
    }, []);

    return (
        <>
        
            { isLoading || categories.length === 0 ?(
                ""
            ):(
                <>
                <section className="venue-categories">
                <div className="venue-container-categories">
                <h2 className="venue-title-categories">Browse Venues in {cityName} by Categories</h2>
                <div className={`venue-grid-categories-${categories.length}`}>
                    {categories.map((category, index) => (
                        <a href={`${BASEURL}/${CityUniqueLink}/${category.uniqueLink}`} target='_blank' >
                        <div key={index} className="venue-card-categories" >
                        <div className="venue-image-container-categories">
                            <img 
                            src={category.image}
                            alt={category.occasionCategoryName}
                            className="venue-image-categories"
                            />
                        </div>
                        <p className="venue-category-title">{category.occasionCategoryName}</p>
                        </div>
                        </a>
                    ))}
                </div>
            </div>
            {/* Mobile View */}
            <div className='Carousel-Mobile-view' >          
                <div className="mobile-carousel">
                    <div className="mobile-carousel__container">
                    {categories.map((category, index) => (
                        <a href={`${BASEURL}/${CityUniqueLink}/${category.uniqueLink}`} target='_blank' >
                        <div key={index} className="venue-card-categories">
                            <div className="venue-image-container-categories">
                                <img 
                                src={category.image} 
                                alt={category.title}
                                className="venue-image-categories"
                                />
                            </div>
                        <p className="venue-category-title">{category.occasionCategoryName}</p>
                        </div>
                        </a>
                    ))}
                    </div>
                </div>
            </div>
            </section>
            </>
            )}
        </>
    );
    };

    export default VenueCategories;